import { Button, Modal, Text } from '@pentabd/ui';
import { IconXCircle } from '@pentabd/icons';

interface ErrorModalType {
  isModalOpen: boolean;
  closeModal: () => void;
  title?: string;
  subtitle?: string;
}

export const ErrorModal = ({
  isModalOpen,
  closeModal,
  title = 'Error',
  subtitle = 'Something went wrong',
}: ErrorModalType) => {
  return (
    <Modal
      isOpen={isModalOpen}
      overlay={isModalOpen}
      onClose={closeModal}
      closeAble
      portal
    >
      <div className="p-10 w-100">
        <div className="d-flex flex-column justify-content-center align-items-center">
          <IconXCircle size="40" fill="danger" />
          <Text
            color="dark"
            size="lg"
            className="pt-8 fs-lg fw-semibold"
            component="p"
          >
            {title}
          </Text>
          <Text color="subtitle1" size="sm" className="pt-2" component="p">
            {subtitle}
          </Text>
        </div>
        <div className="w-max mx-auto mt-10">
          <Button
            key="close"
            className="px-18"
            size="sm"
            htmlType="button"
            fill="outline"
            type="light"
            onClick={closeModal}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};
